var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUppercase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uppercase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M22.4389 8.95115C22.4389 8.95115 21.3309 6 18.1079 6C15.1151 6 13 8.57802 13 12.2415C13 15.922 15.1151 18.5 18.1079 18.5C20.8561 18.4322 22.9856 16.5156 22.9856 13.0047C22.9856 13.0047 23 12.445 23 12.021H18.295M9.37616 13.4792L6.92458 6.65403C6.78313 6.26024 6.42703 6 6.02964 6C5.63395 6 5.279 6.25806 5.13637 6.64945L2.64746 13.4792M9.37616 13.4792L11 18M9.37616 13.4792H2.64746M1 18L2.64746 13.4792",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUppercase);
export default __webpack_public_path__ + "static/media/uppercase.d5d50e15c2bb4c91414eace6edf3ce16.svg";
export { ForwardRef as ReactComponent };